<script>
import { truncate } from '../filters';

export default {
  name: "LerMais",
  props: {
    texto: {
      type: String,
      default: ""
    },
    tamanhoLimite: {
      type: Number,
      default: 250
    }
  },
  data() {
    return {
      lerMaisAtivado: false,
    }
  },
  methods: {
    handleLerMais() {
      this.lerMaisAtivado = !this.lerMaisAtivado;
    },
  },
  computed: {
    textoExibido() {
      return this.lerMaisAtivado ? this.texto : truncate(this.texto, this.tamanhoLimite, false)
    },
    textoBtn() {
      return this.lerMaisAtivado ?  'Ler menos' : 'Ler mais'
    },
    textoUltrapassaouLimite() {
      return this.texto.length > this.tamanhoLimite;
    }
  }
}
</script>

<template>
  <div>
      <p>{{ textoExibido }}</p>
      <a v-if="textoUltrapassaouLimite" @click="handleLerMais" class="cursor-pointer underline">
        {{ textoBtn }}
      </a>
  </div>
</template>
